// extracted by mini-css-extract-plugin
module.exports = {"eccComicsDiscountsBody":"Discounts_eccComicsDiscountsBody__PdKYP","discountWrapper":"Discounts_discountWrapper__m0Y2U","discountContainer":"Discounts_discountContainer__9wF9r"};